import React from 'react';
import * as api from 'app/shared/api';
import { useDispatch } from 'react-redux';
import {
  listCourseProductsData,
  listAddOnsProductsData,
  listTransferssProductsData,
} from 'app/pages/Products/actions';
import { getSelectedDivisionIdOrUndefined } from 'app/shared/division/selectedDivisionStorage';

const DivisionWatcher: React.FC = () => {
  const dispatch = useDispatch();
  const [divisionId, setDivisionId] = React.useState(getSelectedDivisionIdOrUndefined());
  const lastFetchedDivision = React.useRef<number | undefined>(divisionId);

  React.useEffect(() => {
    const onDivisionChanged = () => {
      setDivisionId(getSelectedDivisionIdOrUndefined());
    };
    window.addEventListener('selectedDivisionChanged', onDivisionChanged);
    return () => window.removeEventListener('selectedDivisionChanged', onDivisionChanged);
  }, []);

  React.useEffect(() => {
    if (!divisionId) return;
    if (lastFetchedDivision.current === divisionId) return;
    lastFetchedDivision.current = divisionId;

    api.getCourseProducts(divisionId).then(products => dispatch(listCourseProductsData(products)));
    api.getAddonsProducts(divisionId).then(products => dispatch(listAddOnsProductsData(products)));
    api.getTransferProducts(divisionId).then(products => dispatch(listTransferssProductsData(products)));
  }, [divisionId, dispatch]);

  return null;
};

export default DivisionWatcher;
